import { EnvApiKeyInfo } from '@typesApp/Config'
import apikeyDev from './apikey-dev.json'
import apikeyProd from './apikey-prod.json'
import apikeyStage from './apikey-stage.json'
import apikeyTest from './apikey-test.json'

export const apiKeyConfig = {
  DEV: {
    commerceEnv: 'dev',
    keys: { ...apikeyDev },
  },
  TEST: {
    commerceEnv: 'int',
    keys: { ...apikeyTest },
  },
  STAGE: {
    commerceEnv: 'uat',
    keys: { ...apikeyStage },
  },
  PROD: {
    commerceEnv: 'prod',
    keys: { ...apikeyProd },
  },
} as Record<'DEV' | 'TEST' | 'STAGE' | 'PROD', EnvApiKeyInfo>
